interface GearWithSchemaSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearWithSchemaSVG = ({ color, style }: GearWithSchemaSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="50"
    viewBox="0 0 47 50"
    fill="none"
  >
    <g clipPath="url(#clip0_519_19453)">
      <path
        d="M23.2456 28.2539V33.2331"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M23.2456 42.2885V33.2334"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M42.2614 42.2878V36.996C42.2614 35.0275 40.6445 33.418 38.641 33.418H7.83818C5.84637 33.418 4.21777 35.0159 4.21777 36.996V42.2878"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1.66363 42.2881H6.78376C7.34615 42.2881 7.79138 42.7397 7.79138 43.2839V48.3441C7.79138 48.8999 7.33443 49.34 6.78376 49.34H1.66363C1.10123 49.34 0.656006 48.8884 0.656006 48.3441V43.2839C0.656006 42.7281 1.11295 42.2881 1.66363 42.2881Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.6795 42.2881H25.7996C26.362 42.2881 26.8072 42.7397 26.8072 43.2839V48.3441C26.8072 48.8999 26.3503 49.34 25.7996 49.34H20.6795C20.1171 49.34 19.6719 48.8884 19.6719 48.3441V43.2839C19.6719 42.7281 20.1288 42.2881 20.6795 42.2881Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.6956 42.2881H44.8157C45.3781 42.2881 45.8234 42.7397 45.8234 43.2839V48.3441C45.8234 48.8999 45.3664 49.34 44.8157 49.34H39.6956C39.1332 49.34 38.688 48.8884 38.688 48.3441V43.2839C38.688 42.7281 39.1449 42.2881 39.6956 42.2881Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.4421 19.7008C28.3774 18.4992 29.7713 15.1733 28.5555 12.2723C27.3396 9.37132 23.9744 7.99371 21.039 9.19535C18.1037 10.397 16.7098 13.7228 17.9256 16.6238C19.1415 19.5248 22.5067 20.9024 25.4421 19.7008Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M35.958 10.1204L36.5087 9.55302L34.1654 5.54654L33.3921 5.73181C31.822 6.11393 30.17 5.8476 28.7757 5.04862C28.764 5.04862 28.7406 5.02546 28.7289 5.02546C27.3229 4.22648 26.2567 2.94117 25.7997 1.4011L25.5771 0.648438H20.8905L20.6679 1.4011C20.2227 2.94117 19.1565 4.22648 17.7505 5.02546C17.7505 5.02546 17.7388 5.02546 17.727 5.03704C17.727 5.03704 17.7153 5.03704 17.7036 5.04862C16.2976 5.85918 14.6456 6.12551 13.0756 5.74339L12.3023 5.55812L9.95898 9.5646L10.5097 10.132C11.6344 11.2899 12.2203 12.8416 12.2203 14.4511C12.2203 14.4743 12.2203 14.4859 12.2203 14.509C12.2203 16.107 11.6344 17.6586 10.5097 18.805L9.95898 19.3724L12.3023 23.3789L13.0756 23.1936C14.6456 22.8115 16.2976 23.0778 17.6919 23.8768C17.7036 23.8768 17.727 23.8999 17.7388 23.8999C19.1448 24.6989 20.211 25.9842 20.6679 27.5243L20.8905 28.277H25.5771L25.7997 27.5243C26.245 25.9842 27.3112 24.6989 28.7172 23.8999C28.7172 23.8999 28.7289 23.8999 28.7406 23.8884C28.7406 23.8884 28.7523 23.8884 28.764 23.8768C30.17 23.0662 31.822 22.7999 33.3921 23.182L34.1654 23.3673L36.5087 19.3608L35.958 18.7934C34.8332 17.6355 34.2474 16.0838 34.2474 14.4743C34.2474 14.4511 34.2474 14.4395 34.2474 14.4164C34.2474 12.8184 34.8332 11.2668 35.958 10.1204Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_19453">
        <rect width="46.4912" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GearWithSchemaSVG;
